import 'video-react/dist/video-react.css'; // import css

import { Icon } from '@smartgift/frontend-toolkit';
import { useState } from 'react';
import { Player, ControlBar } from 'video-react';

import * as S from './style';

function VideoCard({ url, onClick, style, playable = true, ratio }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [player, setPlayer] = useState(null);

  return (
    <S.VideoCard style={style} isPlaying={isPlaying} playable={playable} hasRatio={!!ratio}>
      <Player width="100%" height="100%" ref={setPlayer} aspectRatio={ratio}>
        <source src={url} />
        <ControlBar />
      </Player>
      {!isPlaying && (
        <S.VideoCardOverlay onClick={onClick}>
          <S.VideoCardOverlayIcon
            onClick={() => {
              if (playable) {
                player.play();
                setIsPlaying(true);
              }
            }}
          >
            <Icon className="play" name="play" size="lg" color="var(--color-background-default)" />
          </S.VideoCardOverlayIcon>
        </S.VideoCardOverlay>
      )}
    </S.VideoCard>
  );
}

export { VideoCard };
